import React, { useContext, useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import FormMultiSelectBox from "src/components/Forms/FormMultiSelectBox";
import FormSelectBox from "src/components/Forms/FormSelectBox";
import { localeOptions } from "src/global";
import {
  showSuccessToast,
  showValidationErrorToast,
} from "src/components/Toasts";
import axios from "src/config/axios";
import { DashboardContext } from "src/routes/DashboardRoutes";

const LanguageSettingsDialog = ({ handleClose }) => {
  const [business, setBusiness] = useState();
  const { configuration, languages } = useContext(DashboardContext);
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    axios.get("/api/v1/businesses/me.json").then(({ data }) => {
      setBusiness(data);
    });
  }, []);

  function handleSubmit(values, helpers) {
    helpers.setSubmitting(true);

    axios
      .put("/api/v1/businesses/me_update.json", { business: values })
      .then(({ data }) => {
        setBusiness(data);
        showSuccessToast();
        handleClose();
      })
      .catch((error) => {
        showValidationErrorToast(error);
      })
      .finally(() => {
        helpers.setSubmitting(false);
      });
  }

  function handleLocalesChange(locales, values, setFieldValue) {
    setFieldValue("locales", locales);

    if (!locales.includes(values.default_locale)) {
      setFieldValue("default_locale", "");
    }
  }

  return (
    <Modal show={true} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          {t(
            "settings.business.ticket_vending_machine.language_settings.title"
          )}
        </Modal.Title>
      </Modal.Header>
      {!business ? (
        <Modal.Body>
          <Spinner
            className={"d-block mx-auto"}
            animation="border"
            variant="primary"
          />
        </Modal.Body>
      ) : (
        <Formik
          initialValues={{ ...business }}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, setFieldValue, values }) => (
            <Form>
              <Modal.Body>
                <FormMultiSelectBox
                  name="locales"
                  label={t("settings.business.general.locales.label")}
                  hint={t("settings.business.general.locales.hint")}
                  options={configuration.available_locales}
                  option_value={"locale"}
                  onChange={(locales) =>
                    handleLocalesChange(locales, values, setFieldValue)
                  }
                />
                <FormSelectBox
                  name="default_locale"
                  label={t("settings.business.general.default_locale.label")}
                  hint={t("settings.business.general.default_locale.hint")}
                  options={localeOptions(configuration, values.locales).filter(
                    ({ locale }) => languages.includes(locale)
                  )}
                  option_value={"locale"}
                />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  disabled={isSubmitting}
                  onClick={handleClose}
                  type={"button"}
                  variant={"secondary"}
                >
                  {t("common:components.button.close")}
                </Button>
                <Button disabled={isSubmitting} type={"submit"}>
                  {t("common:components.button.save")}
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      )}
    </Modal>
  );
};

export default LanguageSettingsDialog;
